import { CommApiInstance } from "Utils/CommApiInstance";

const SsoCallBackApi = async (
    referrer:string,
    code:string|null,
    state:string|null,
) => {

        return await CommApiInstance.post(`/athn/login/callback/${referrer}`,{
            apiBody:{
                oauth2Tkn:code,
                state:state,
            },
        })
        .then((Resp) => Resp.data);
    }

export default SsoCallBackApi;